import * as React from "react";

import { createBrowserRouter, RouterProvider } from "react-router-dom";

import PageTemplateOffline from "./PageTemplateOffline";
import RequireSysAdmin from "./RequireSysAdmin";

// page imports
const NotFound = React.lazy(() => import("../pages/NotFound"))

const HomePage = React.lazy(() => import("../pages/HomePage"));
const DashboardPage = React.lazy(() => import("../pages/DashboardPage"));

const LogoutPage = React.lazy(() => import("../pages/LogoutPage"));

const ReviewPage = React.lazy(() => import("../pages/ReviewPage"));
const ResearchPage = React.lazy(() => import("../pages/ResearchPage"));
const SecurityPage = React.lazy(() => import("../pages/SecurityPage"));

const BoxPage = React.lazy(() => import("../pages/BoxPage"));

const UserPage = React.lazy(() => import("../pages/UserPage"));
const UsersPage = React.lazy(() => import("../pages/UsersPage"))
const UserCreatePage = React.lazy(() => import("../pages/UserCreatePage"));

const RolePage = React.lazy(() => import("../pages/RolePage"));
const RolesPage = React.lazy(() => import("../pages/RolesPage"));
const RoleCreatePage = React.lazy(() => import("../pages/RoleCreatePage"));

const GroupPage = React.lazy(() => import("../pages/GroupPage"));
const GroupsPage = React.lazy(()=> import("../pages/GroupsPage"));
const GroupCreatePage = React.lazy(() => import("../pages/GroupCreatePage"));

const PolicyPage = React.lazy(() => import("../pages/PolicyPage"));
const PoliciesPage = React.lazy(() => import("../pages/PoliciesPage"));
const PolicyEditPage = React.lazy(() => import("../pages/PolicyEditPage"));
const PolicyCreatePage = React.lazy(() => import("../pages/PolicyCreatePage"));

const ScopePage = React.lazy(() => import("../pages/ScopePage"));
const ScopesPage = React.lazy(() => import("../pages/ScopesPage"));
const ScopeEditPage = React.lazy(() => import("../pages/ScopeEditPage"));
const ScopeCreatePage = React.lazy(() => import("../pages/ScopeCreatePage"));

const SessionPage = React.lazy(() => import("../pages/SessionPage"));

const ConfigurationManagementPage = React.lazy(() => import("../pages/ConfigurationManagementPage"));

const AttributeNewPage = React.lazy(() => import("../pages/AttributeNewPage"));
const AttributeEditPage = React.lazy(() => import("../pages/AttributeEditPage"));
const AttributeCatalogPage = React.lazy(() => import("../pages/AttributeCatalogPage"));
const AttributeOverviewPage = React.lazy(() => import("../pages/AttributeOverviewPage"));
const AttributeMovePage = React.lazy(() => import("../pages/AttributeMovePage"));

const AutomationPage = React.lazy(() => import("../pages/AutomationPage"));

const RegexNewPage = React.lazy(() => import("../pages/RegexNewPage"));
const RegexEditPage = React.lazy(() => import("../pages/RegexEditPage"));
const RegexCatalogPage = React.lazy(() => import("../pages/RegexCatalogPage"));
const RegexOverviewPage = React.lazy(() => import("../pages/RegexOverviewPage"));

const AttributeDataExtractionRuleNewPage = React.lazy(() => import("../pages/AttributeDataExtractionRuleNewPage"));
const AttributeDataExtractionRuleEditPage = React.lazy(() => import("../pages/AttributeDataExtractionRuleEditPage"));
const AttributeDataExtractionRuleCatalogPage = React.lazy(() => import("../pages/AttributeDataExtractionRuleCatalogPage"));
const AttributeDataExtractionRuleOverviewPage = React.lazy(() => import("../pages/AttributeDataExtractionRuleOverviewPage"));
const ExtractionPromptLibraryPage = React.lazy(() => import("../pages/ExtractionPromptLibraryPage"));
const ExtractionPromptLibraryEditPage = React.lazy(() => import("../pages/ExtractionPromptLibraryEditPage"));

const TaxonomyNewPage = React.lazy(() => import("../pages/TaxonomyNewPage"));
const TaxonomyEditPage = React.lazy(() => import("../pages/TaxonomyEditPage"));
const TaxonomyCatalogPage = React.lazy(() => import("../pages/TaxonomyCatalogPage"));
const TaxonomyOverviewPage = React.lazy(() => import("../pages/TaxonomyOverviewPage"));

const PromptQualityIssueNewPage = React.lazy(() => import("../pages/PromptQualityIssueNewPage"));
const PromptQualityIssueEditPage = React.lazy(() => import("../pages/PromptQualityIssueEditPage"));
const PromptQualityIssueCatalogPage = React.lazy(() => import("../pages/PromptQualityIssueCatalogPage"));
const PromptQualityIssueOverviewPage = React.lazy(() => import("../pages/PromptQualityIssueOverviewPage"));

const WorkflowNewPage = React.lazy(() => import("../pages/WorkflowNewPage"));
const WorkflowEditPage = React.lazy(() => import("../pages/WorkflowEditPage"));
const WorkflowCatalogPage = React.lazy(() => import("../pages/WorkflowCatalogPage"));
const WorkflowOverviewPage = React.lazy(() => import("../pages/WorkflowOverviewPage"));

const PIIEntityNewPage = React.lazy(() => import("../pages/PIIEntityNewPage"));
const PIIEntityEditPage = React.lazy(() => import("../pages/PIIEntityEditPage"));
const PIIEntityCatalogPage = React.lazy(() => import("../pages/PIIEntityCatalogPage"));
const PIIEntityOverviewPage = React.lazy(() => import("../pages/PIIEntityOverviewPage"));

const ProjectCreatePage = React.lazy(() => import("../pages/ProjectCreatePage"));
const ProjectDetailPage = React.lazy(() => import("../pages/ProjectDetailPage"));
const ProjectCatalogPage = React.lazy(() => import("../pages/ProjectCatalogPage"));
const ProjectOverviewPage = React.lazy(() => import("../pages/ProjectOverviewPage"));

const CollectionEditPage = React.lazy(() => import("../pages/CollectionEditPage"));
const CreateCollectionPage = React.lazy(() => import("../pages/CreateCollectionPage"));

const ListManagerCatalogPage = React.lazy(() => import("../pages/ListManagerCatalogPage"));
const ListManagerSolrPage = React.lazy(() => import("../pages/ListManagerSolrPage"));
const ListManagerCreatePage = React.lazy(() => import("../pages/ListManagerCreatePage"));
const ListManagerOverviewPage = React.lazy(() => import("../pages/ListManagerOverviewPage"));

const ListManagerSelectedListPage = React.lazy(() => import("../pages/ListManagerSelectedListPage"));

const DataAdminPipelineSessionPage = React.lazy(() => import("../pages/DataAdminPipelineSessionPage"));
const DataAdminPipelineCollectionPage = React.lazy(() => import("../pages/DataAdminPipelineCollectionPage"));
const DataAdminPipelineCollectionsPage = React.lazy(() => import("../pages/DataAdminPipelineCollectionsPage"));
const DataAdminPipelineBoxPage = React.lazy(() => import("../pages/DataAdminPipelineBoxPage"));

const DataAdminBoxPage = React.lazy(() => import("../pages/DataAdminBoxPage"));
const DataAdminBoxesPage = React.lazy(() => import("../pages/DataAdminBoxesPage"));
const DataAdminBoxesZipfilePage = React.lazy(() => import("../pages/DataAdminBoxesZipfilePage"));

const DataAdminSessionsIndexPage = React.lazy(() => import("../pages/DataAdminSessionsIndexPage"));
const DataAdminSessionsDetailPage = React.lazy(() => import("../pages/DataAdminSessionsDetailPage"));

const DataAdminHistoriesPage = React.lazy(() => import("../pages/DataAdminHistoriesPage"));

const DataAdminErrorsPage = React.lazy(() => import("../pages/DataAdminErrorsPage"));

const WIBLibRegexNewPage = React.lazy(() => import("../pages/WIBLibRegexNewPage"));
const WibLibRegexDetailPage = React.lazy(() => import("../pages/WibLibRegexDetailPage"));
const WIBLibRegexCatalogPage = React.lazy(() => import("../pages/WIBLibRegexCatalogPage"));
const WIBLibRegexOverviewPage = React.lazy(() => import("../pages/WIBLibRegexOverviewPage"));

const WIBLibListDetailPage = React.lazy(() => import("../pages/WIBLibListDetailPage"));
const WIBLibraryListCatalogPage = React.lazy(() => import("../pages/WIBLibListCatalogPage"));
const WIBLibraryListOverviewPage = React.lazy(() => import("../pages/WIBLibListOverviewPage"));

const ExportPackagePage = React.lazy(() => import("../pages/ExportPackagePage"));
const ExportPackagesPage = React.lazy(() => import("../pages/ExportPackagesPage"));

const AIUsageMetricsPage = React.lazy(() => import("../pages/AIUsageMetricsPage"));

const WorkspaceSettingsPage = React.lazy(() => import("../pages/WorkspaceSettingsPage"));

const ExportPackageConfigurationPage = React.lazy(() => import("../pages/ExportPackageConfigurationPage"));
const ExportPackageConfigurationsPage = React.lazy(() => import("../pages/ExportPackageConfigurationsPage"));
const ExportPackageConfigurationCreatePage = React.lazy(() => import("../pages/ExportPackageConfigurationCreatePage"));
const ExportPackageConfigurationEditPage = React.lazy(() => import("../pages/ExportPackageConfigurationEditPage"));

const ExportPackageSchedulesPage = React.lazy(() => import("../pages/ExportPackageSchedulesPage"));
const ExportPackageScheduleCreatePage = React.lazy(() => import("../pages/ExportPackageScheduleCreatePage"));
const ExportPackageSchedulePage = React.lazy(() => import("../pages/ExportPackageSchedulePage"));
const ExportPackageScheduleEditPage = React.lazy(() => import("../pages/ExportPackageScheduleEditPage"));

const ExportTargetPage = React.lazy(() => import("../pages/ExportTargetPage"));
const ExportTargetsPage = React.lazy(() => import("../pages/ExportTargetsPage"));
const ExportTargetEditPage = React.lazy(() => import("../pages/ExportTargetEditPage"));
const ExportTargetCreatePage = React.lazy(() => import("../pages/ExportTargetCreatePage"));

const TagPage = React.lazy(() => import("../pages/TagPage"));
const TagsPage = React.lazy(() => import("../pages/TagsPage"));
const TagEditPage = React.lazy(() => import("../pages/TagEditPage"));
const TagCreatePage = React.lazy(() => import("../pages/TagCreatePage"));

const ExportPackageHistoryPage = React.lazy(() => import("../pages/ExportPackageHistoryPage"));

const ImageViewerPopupPage = React.lazy(() => import("../pages/ImageViewerPopupPage"));

const TelerikReportViewerPage = React.lazy(() => import("../pages/TelerikReportViewerPage"));

const ReportsPage = React.lazy(() => import("../pages/ReportsPage"));
const ReportsExportHistoryPage = React.lazy(() => import("../pages/ReportsExportHistoryPage"));
const ReportsChristaReportPage = React.lazy(() => import("../pages/ReportsScannerBarcodeDurationPage"));
const ReportsReconciliationReportPage = React.lazy(() => import("../pages/ReportsReconciliationReportPage"));

const ReportsExportPage = React.lazy(() => import("../pages/ReportsExportPage"));
const ReportsExportsPage = React.lazy(() => import("../pages/ReportsExportsPage"));

const ReportsExportSchedulePage = React.lazy(() => import("../pages/ReportsExportSchedulePage"));
const ReportsExportSchedulesPage = React.lazy(() => import("../pages/ReportsExportSchedulesPage"));
const ReportsExportScheduleEditPage = React.lazy(() => import("../pages/ReportsExportScheduleEditPage"));
const ReportsExportScheduleCreatePage = React.lazy(() => import("../pages/ReportsExportScheduleCreatePage"));

const NotificationLogPage = React.lazy(() => import("../pages/NotificationLogPage"));

const BoxExceptionZipfilePage = React.lazy(() => import("../pages/BoxExceptionZipfilePage"));

const router = createBrowserRouter([
  { path: "/", element: <HomePage /> },
  { path: "/dashboard", element: <DashboardPage /> },

  { path: "/auth/logout", element: <LogoutPage /> },

  { path: "/review", element: <ReviewPage /> },
  { path: "/research", element: <ResearchPage /> },

  { path: "/security", element: <SecurityPage /> },

  { path: "/security/users", element: <UsersPage /> },
  { path: "/security/users/create", element: <UserCreatePage /> },
  { path: "/security/users/:userId", element: <UserPage /> },

  { path: "/security/roles", element: <RolesPage /> },
  { path: "/security/roles/create", element: <RoleCreatePage /> },
  { path: "/security/roles/:roleId", element: <RolePage /> },

  { path: "/security/groups", element: <GroupsPage /> },
  { path: "/security/groups/create", element: <GroupCreatePage /> },
  { path: "/security/groups/:groupId", element: <GroupPage /> },

  { path: "/security/policies", element: <PoliciesPage /> },
  { path: "/security/policies/create", element: <PolicyCreatePage /> },
  { path: "/security/policies/:policyId", element: <PolicyPage /> },
  { path: "/security/policies/:policyId/edit", element: <PolicyEditPage /> },

  { path: "/security/scopes", element: <ScopesPage /> },
  { path: "/security/scopes/create", element: <ScopeCreatePage /> },
  { path: "/security/scopes/:scopeId", element: <ScopePage /> },
  { path: "/security/scopes/:scopeId/edit", element: <ScopeEditPage /> },

  { path: "/box/:boxId", element: <BoxPage /> },

  { path: "/session/:sessionId", element: <SessionPage /> },

  { path: "/configuration-management", element: <ConfigurationManagementPage /> },

  { path: "/configuration-management/attributes", element: <AttributeOverviewPage /> },
  { path: "/configuration-management/attributes/new", element: <AttributeNewPage /> },
  { path: "/configuration-management/attributes/move", element: <AttributeMovePage /> },
  { path: "/configuration-management/attributes/catalog", element: <AttributeCatalogPage /> },
  { path: "/configuration-management/attributes/:attributeId", element: <AttributeEditPage /> },

  { path: "/configuration-management/automation", element: <AutomationPage /> },

  { path: "/configuration-management/automation/regex", element: <RegexOverviewPage /> },
  { path: "/configuration-management/automation/regex/new", element: <RegexNewPage /> },
  { path: "/configuration-management/automation/regex/catalog", element: <RegexCatalogPage /> },
  { path: "/configuration-management/automation/regex/:regexId", element: <RegexEditPage /> },

  { path: "/configuration-management/automation/attribute-data-extraction-rules", element: <AttributeDataExtractionRuleOverviewPage /> },
  { path: "/configuration-management/automation/attribute-data-extraction-rules/new", element: <AttributeDataExtractionRuleNewPage /> },
  { path: "/configuration-management/automation/attribute-data-extraction-rules/catalog", element: <AttributeDataExtractionRuleCatalogPage /> },
  { path: "/configuration-management/automation/attribute-data-extraction-rules/prompt-library", element: <ExtractionPromptLibraryPage /> },
  { path: "/configuration-management/automation/attribute-data-extraction-rules/prompt-library/new", element: <ExtractionPromptLibraryEditPage /> },
  { path: "/configuration-management/automation/attribute-data-extraction-rules/prompt-library/:templateId", element: <ExtractionPromptLibraryEditPage /> },
  { path: "/configuration-management/automation/attribute-data-extraction-rules/:ruleId", element: <AttributeDataExtractionRuleEditPage /> },

  { path: "/configuration-management/automation/taxonomy", element: <TaxonomyOverviewPage /> },
  { path: "/configuration-management/automation/taxonomy/new", element: <TaxonomyNewPage /> },
  { path: "/configuration-management/automation/taxonomy/catalog", element: <TaxonomyCatalogPage /> },
  { path: "/configuration-management/automation/taxonomy/:taxonomyId", element: <TaxonomyEditPage /> },

  { path: "/configuration-management/automation/prompt-quality-issue", element: <PromptQualityIssueOverviewPage /> },
  { path: "/configuration-management/automation/prompt-quality-issue/new", element: <PromptQualityIssueNewPage /> },
  { path: "/configuration-management/automation/prompt-quality-issue/catalog", element: <PromptQualityIssueCatalogPage /> },
  { path: "/configuration-management/automation/prompt-quality-issue/:id", element: <PromptQualityIssueEditPage /> },

  { path: "/configuration-management/automation/pii-entities", element: <PIIEntityOverviewPage /> },
  { path: "/configuration-management/automation/pii-entities/new", element: <PIIEntityNewPage /> },
  { path: "/configuration-management/automation/pii-entities/catalog", element: <PIIEntityCatalogPage /> },
  { path: "/configuration-management/automation/pii-entities/:id", element: <PIIEntityEditPage /> },

  { path: "/configuration-management/automation/list-manager", element: <ListManagerOverviewPage /> },
  { path: "/configuration-management/automation/list-manager/create", element: <ListManagerCreatePage /> },
  { path: "/configuration-management/automation/list-manager/catalog", element: <ListManagerCatalogPage /> },
  { path: "/configuration-management/automation/list-manager/:listId", element: <ListManagerSelectedListPage /> },
  { path: "/configuration-management/automation/list-manager/:listId/solr", element: <ListManagerSolrPage /> },

  { path: "/configuration-management/automation/workflows", element:<WorkflowOverviewPage /> },
  { path: "/configuration-management/automation/workflows/new", element:<WorkflowNewPage /> },
  { path: "/configuration-management/automation/workflows/catalog", element:<WorkflowCatalogPage /> },
  { path: "/configuration-management/automation/workflows/:id", element:<WorkflowEditPage /> },

  { path: "/configuration-management/automation/wib-lib/regex", element: <WIBLibRegexOverviewPage /> },
  { path: "/configuration-management/automation/wib-lib/regex/new", element: <WIBLibRegexNewPage /> },
  { path: "/configuration-management/automation/wib-lib/regex/catalog", element: <WIBLibRegexCatalogPage /> },
  { path: "/configuration-management/automation/wib-lib/regex/:adminRegexId", element: <WibLibRegexDetailPage /> },

  { path: "/configuration-management/automation/wib-lib/list", element: <WIBLibraryListOverviewPage /> },
  { path: "/configuration-management/automation/wib-lib/list/catalog", element: <WIBLibraryListCatalogPage /> },
  { path: "/configuration-management/automation/wib-lib/list/:adminListId", element: <WIBLibListDetailPage /> },

  { path: "/project", element: <ProjectOverviewPage /> },
  { path: "/project/create", element: <ProjectCreatePage /> },
  { path: "/project/catalog", element: <ProjectCatalogPage /> },
  { path: "/project/:projectId", element: <ProjectDetailPage /> },

  { path: "/project/:projectId/new-collection", element: <CreateCollectionPage /> },
  { path: "/project/:projectId/collection/:collectionId", element: <CollectionEditPage /> },

  { path: "/data-admin/pipeline", element: <DataAdminPipelineCollectionsPage /> },
  { path: "/data-admin/pipeline/:collectionId", element: <DataAdminPipelineCollectionPage /> },
  { path: "/data-admin/pipeline/:collectionId/:sessionId", element: <DataAdminPipelineSessionPage /> },
  { path: "/data-admin/pipeline/:collectionId/:sessionId/:boxZipfileId", element: <DataAdminPipelineBoxPage /> },

  { path: "/data-admin/sessions", element: <DataAdminSessionsIndexPage /> },
  { path: "/data-admin/sessions/:id", element: <DataAdminSessionsDetailPage /> },

  { path: "/data-admin/boxes", element: <DataAdminBoxesPage /> },
  { path: "/data-admin/boxes/:id", element: <DataAdminBoxPage /> },
  { path: "/data-admin/boxes/:boxId/:zipfileId", element: <DataAdminBoxesZipfilePage /> },

  { path: "/data-admin/history", element: <DataAdminHistoriesPage /> },

  { path: "/data-admin/errors", element: <DataAdminErrorsPage /> },

  { path: "/data-admin/exception-zipfile/:id", element: <BoxExceptionZipfilePage /> },

  { path: "/export-packages", element: <ExportPackagesPage /> },
  { path: "/export-packages/:id", element: <ExportPackagePage /> },

  { path: "/usage/ai-usage-metrics", element: <RequireSysAdmin><AIUsageMetricsPage /></RequireSysAdmin> },

  { path: "/workspace-settings/quality-levels", element: <WorkspaceSettingsPage /> },

  { path: "/export-package-configurations", element: <ExportPackageConfigurationsPage /> },
  { path: "/export-package-configurations/create", element: <ExportPackageConfigurationCreatePage /> },
  { path: "/export-package-configurations/:id", element: <ExportPackageConfigurationPage /> },
  { path: "/export-package-configurations/:id/edit", element: <ExportPackageConfigurationEditPage /> },

  { path: "/export-package-schedules", element: <ExportPackageSchedulesPage /> },
  { path: "/export-package-schedules/create", element: <ExportPackageScheduleCreatePage /> },
  { path: "/export-package-schedules/:id", element: <ExportPackageSchedulePage /> },
  { path: "/export-package-schedules/:id/edit", element: <ExportPackageScheduleEditPage /> },

  { path: "/export-targets", element: <ExportTargetsPage /> },
  { path: "/export-targets/create", element: <ExportTargetCreatePage /> },
  { path: "/export-targets/:id", element: <ExportTargetPage /> },
  { path: "/export-targets/:id/edit", element: <ExportTargetEditPage /> },

  { path: "/tags", element: <TagsPage /> },
  { path: "/tags/create", element: <TagCreatePage /> },
  { path: "/tags/:id", element: <TagPage /> },
  { path: "/tags/:id/edit", element: <TagEditPage /> },

  { path: "/export-package-history", element: <ExportPackageHistoryPage /> },

  { path: "/image-viewer-popup", element: <ImageViewerPopupPage /> },

  { path: "/telerik-report-viewer", element: <TelerikReportViewerPage /> },

  { path: "/report", element: <ReportsPage /> },
  { path: "/report/export-history", element: <ReportsExportHistoryPage /> },
  { path: "/report/scanner-barcode-duration", element: <ReportsChristaReportPage /> },
  { path: "/report/reconciliation-report", element: <ReportsReconciliationReportPage /> },

  { path: "/report-exports", element: <ReportsExportsPage /> },
  { path: "/report-exports/:id", element: <ReportsExportPage /> },

  { path: "/report-export-schedules", element: <ReportsExportSchedulesPage /> },
  { path: "/report-export-schedules/create", element: <ReportsExportScheduleCreatePage /> },
  { path: "/report-export-schedules/:id", element: <ReportsExportSchedulePage /> },
  { path: "/report-export-schedules/:id/edit", element: <ReportsExportScheduleEditPage /> },

  { path: "/notifications", element: <NotificationLogPage /> },

  { path: "*", element: <NotFound /> },
]);

export default function Router() {
  return (
    <React.Suspense fallback={<PageTemplateOffline />}>
      <RouterProvider router={router} />
    </React.Suspense>
  );
}
